import xhr from 'Common/utils/xhr'

export default function requestTextToSpeech({ text, token, url }) {
  return xhr({
    url,
    headers: {
      Authorization: `Token ${token}`,
    },
    method: 'POST',
    data: {
      speech: {
        text,
        voice_name: 'en-US-Wavenet-F',
      },
    },
  }).then(res => res.data)
}
